import { NavLink } from 'react-router';
import { House, ListBullets, CalendarCheck, ChartBar, GearSix, Sparkle, type Icon as PhosphorIcon } from '@phosphor-icons/react';

interface Item { to: string; label: string; icon: PhosphorIcon; end?: boolean }

export function BottomNav({ items, label }: { items: Item[]; label: string }) {
  return (
    <nav className="bottom-nav glass" aria-label={label}>
      <ul>
        {items.map((it) => (
          <li key={it.to}>
            <NavLink to={it.to} end={it.end}>
              {({ isActive }) => (
                <>
                  <it.icon size={24} weight={isActive ? 'fill' : 'regular'} aria-hidden />
                  <span>{it.label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export const clientNav = (base: string): Item[] => [
  { to: base, label: 'Главная', icon: House, end: true },
  { to: `${base}services`, label: 'Услуги', icon: ListBullets },
  { to: `${base}my`, label: 'Моя запись', icon: CalendarCheck },
];

export const ownerNav = (base: string): Item[] => [
  { to: `${base}owner/`, label: 'Записи', icon: CalendarCheck, end: true },
  { to: `${base}owner/stats`, label: 'Итоги', icon: ChartBar },
  { to: `${base}owner/assistant`, label: 'Помощник', icon: Sparkle },
  { to: `${base}owner/settings`, label: 'Настройки', icon: GearSix },
];
